export default {
    computed: {
        sectionsGroupList() {
            // create section groups
            const sectionGroups = this.rootSections.reduce((acc, section) => {
                acc[section.id] = acc[section.id] || [];
                acc[section.id].push(section);

                return acc;
            }, {});

            // Sort repeatable section groups
            return Object.values(sectionGroups).map((sectionGroup) => {
                if (sectionGroup[0].is_repeatable) {
                    return sectionGroup.sort(
                        (sectionA, sectionB) =>
                            sectionA.section_sort_index - sectionB.section_sort_index
                    );
                }

                return sectionGroup;
            });
        },
        currentRepeatableSection() {
            return this.rootSections?.find(
                (section) => section?.clientData?.isCreate || section?.clientData?.isUpdate
            );
        },
    },
};
